export default "__VITE_ASSET__CXabYQPl__"